import { render, staticRenderFns } from "./ClientAssignment.component.vue?vue&type=template&id=7deed8a4&scoped=true&"
import script from "./ClientAssignment.component.vue?vue&type=script&lang=js&"
export * from "./ClientAssignment.component.vue?vue&type=script&lang=js&"
import style0 from "./ClientAssignment.component.vue?vue&type=style&index=0&id=7deed8a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deed8a4",
  null
  
)

export default component.exports